import { NgModule } from '@angular/core';
import { SafeContentPipe } from './safe-content.pipe';


@NgModule({
  declarations: [
    SafeContentPipe,
  ],
  exports: [
    SafeContentPipe,
  ]
})
export class SafeContentModule {}
